import styles from "./GuideNav.module.scss";
import ScrollNav from "@/components/ui/nav/ScrollNav/ScrollNav";

export default function GuideNav({ data }) {
  const isActive = {};

  if (data) {
    for (const section in data) {
      if (data[section]) {
        isActive[section] = true;
      }

      if (section === "useful_phrases") {
        if (
          data[section]?.language?.toLowerCase() === "english" ||
          data[section]?.thank_you?.native?.toLowerCase() === "thank you"
        ) {
          isActive[section] = false;
        }
      }
    }
  }

  const anchorTags = [
    {
      tag: "inputs",
      text: "Inputs",
      active: isActive.hasOwnProperty("inputs"),
    },
    {
      tag: "key-facts",
      text: "Facts",
      active: isActive.hasOwnProperty("key_facts"),
    },
    {
      tag: "useful-phrases",
      text: "Phrases",
      active:
        isActive.hasOwnProperty("useful_phrases") &&
        isActive?.useful_phrases === true,
    },
    {
      tag: "introduction",
      text: "Introduction",
      active: isActive.hasOwnProperty("introduction"),
    },
    {
      tag: "travel_logistics",
      text: "Travel",
      active: isActive.hasOwnProperty("travel_logistics"),
    },
    {
      tag: "climate_and_seasons",
      text: "Climate",
      active: isActive.hasOwnProperty("climate_and_seasons"),
    },
    {
      tag: "itinerary",
      text: "Itinerary",
      active: !!(
        isActive.hasOwnProperty("itinerary") &&
        data?.itinerary?.length &&
        data?.itinerary?.[0]?.id
      ),
    },
    {
      tag: "accommodations",
      text: "Accommodations",
      active: isActive.hasOwnProperty("accommodations"),
    },
    {
      tag: "food_and_drink",
      text: "Food",
      active: isActive.hasOwnProperty("food_and_drink"),
    },
    {
      tag: "attractions_and_activities",
      text: "Activities",
      active: isActive.hasOwnProperty("attractions_and_activities"),
    },
    {
      tag: "other_experiences",
      text: "Different Experiences",
      active: isActive.hasOwnProperty("other_experiences"),
    },
  ];

  return (
    <section className={`${styles.nav}`}>
      <ScrollNav anchorTags={anchorTags} style="miniButtons" />
    </section>
  );
}
